import React from 'react';
import { Link } from 'react-router-dom';
import ImageBlock from '../../widgets/image-block';
const MaybeIcon = (props) => {
    const { icon } = props;
    return icon ? (
        <>
            {icon}
            <div className="ml-2">{props.children}</div>
        </>
    ) : (
        <>{props.children}</>
    );
};

const MaybeImage = (props) => {
    const { image, postImage } = props;
    return image ? (
        <>
            <ImageBlock className="mr-2 w-auto" data={image}/> 
            {props.children}
        </>
    ) : postImage ? (
        <>
            {props.children}
            <ImageBlock className="ml-2 w-auto" data={postImage}/> 
        </>
    ) : (
        <>{props.children}</>
    );
};

const SimpleLinkCmp = (props) => {
    const { url, icon, image, postImage, attributes, ...others } = props;

    return (
        <a href={url} {...others} {...attributes}>
            <MaybeIcon icon={icon}>
                <MaybeImage image={image} postImage={postImage}>
                    {props.children}
                </MaybeImage>
            </MaybeIcon>
        </a>
    );
};

const RouteLinkCmp = (props) => {
    const { url, icon, image, postImage, attributes, ...others } = props;

    return (
        <Link to={url} {...others} {...attributes}>
            <MaybeIcon icon={icon}>
                <MaybeImage image={image} postImage={postImage}>
                    {props.children}
                </MaybeImage>
            </MaybeIcon>
        </Link>
    );
};

const LinkBase = (props) => {
    const { className, external, url, ...others } = props;
    const css = `${
        props.disabled
            ? 'inline-block opacity-50 pointer-events-none'
            : 'inline-block'
    } ${className ?? ''}`;
    return external || !url ? (
        <SimpleLinkCmp className={css} url={url} {...others} />
    ) : (
        <RouteLinkCmp url={url} className={css} {...others} />
    );
};

export const LinkButtonPrimary = (props) => {
    const { className, ...others } = props;
    const css = `flex-inline items-center px-8 py-4 rounded-xl text-white bg-skin-button hover:bg-skin-button-hover font-semibold border border-skin-button hover:border-skin-button-hover flex justify-center ${
        className ?? ""
    }`;
    return <LinkBase className={css} {...others} />;
};

export const LinkButtonPrimaryBorder = (props) => {
    const { className, ...others } = props;
    const css = `flex-inline items-center px-8 py-2 rounded-xl text-skin-primary font-semibold border border-skin-button hover:border-skin-button-hover flex justify-center ${
        className ?? ''
    }`;
    return <LinkBase className={css} {...others} />;
};

export const LinkButtonSelect = (props) => {
    const { className, ...others } = props;
    const css = `px-10 py-3 rounded-full text-white font-semibold bg-skin-primary cursor-pointer ${
        className ?? ''
    }`;
    return <LinkBase className={css} {...others} />;
};

export const LinkButtonSecondary = (props) => {
    const { className, ...others } = props;
    const css = `px-10 py-3 rounded-full text-white font-semibold bg-skin-secondary cursor-pointer flex justify-center ${
        className ?? ''
    }`;
    return <LinkBase className={css} {...others} />;
};

export const ButtonPrimary = (props) => {
    const { className, ...others } = props;
    const css = `px-8 py-2 rounded-full text-white bg-skin-primary ${
        props.disabled ? 'opacity-50' : ''
    } ${className ?? ''}`;
    return (
        <button className={css} {...others}>
            {props.children}
        </button>
    );
};
